import { withKeycloak } from "@react-keycloak/web";
import { Popover } from "antd";
import { default as React } from "react";
import { Button } from "react-bootstrap";
import FileIcon from "react-file-icon";
import { labels } from "../../../../../localization/labels";
import { messages } from "../../../../../localization/messages";
import DocumentService from "../../../../../services/DocumentService";
import Table from "../../../../core/Table";
import TableFormatter from "../../../../core/Table/TableUtils";
import PageComponent from "../../../page/PageComponent";
import { getSearchableIcon } from "./Document";

class SimilarDocuments extends PageComponent {
  constructor(props) {
    super(props);

    this.documentService = new DocumentService(this.keycloak);

    this.state = {
      similarDocuments: []
    };
  }

  componentDidMount() {
    this.initContainer();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.document?.id !== this.props.document?.id) {
      this.initContainer();
    }
  }

  initContainer() {
    if (this.props.document) {
      this.loadSimilarDocuments(this.props.document);
    } else {
      this.setState({ similarDocuments: [] });
    }
  }

  loadSimilarDocuments = document => {
    const url = document?._links?.similarDocuments?.href;
    if (url) {
      this.prepareCall(
        this.documentService.getEntitiesByUrl(
          url,
          this.onLoadSimilarDocumentsLoad,
          this.messageHandler.handleError
        )
      );
      this.performCalls();
    }
  };

  onLoadSimilarDocumentsLoad = data => {
    this.setState({
      similarDocuments: data?._embedded?.content
    });
  };

  onDocumentDownload = document => {
    const confirm = window.confirm(messages.download_confirm_message);
    if (confirm) {
      this.prepareCall(
        this.documentService.downloadDocument(
          document._links.download.href,
          this.messageHandler.handleError
        )
      );
      this.performCalls();
    }
  };

  columns = [
    {
      dataField: "name",
      text: labels.name,
      formatter: TableFormatter.textFormatter
    },
    {
      dataField: "description",
      text: labels.description,
      formatter: TableFormatter.textFormatter
    },
    {
      dataField: "recordedTimeStamp",
      text: labels.dateCreated,
      formatter: TableFormatter.dateFormatter
    },
    {
      dataField: "contentType",
      headerClasses: "column-id",
      text: labels.contentType,
      formatter: (cellContent, row) => {
        return (
          <div className="column-id">
            <FileIcon size="30" extension={row.extension.id} />
          </div>
        );
      }
    },
    {
      dataField: "searchableStatus",
      headerClasses: "column-id",
      text: labels.searchable,
      formatter: (cellContent, row) => (
        <Popover
          content={cellContent ? messages[cellContent.label] : undefined}
          placement="topLeft"
        >
          <div className="column-id">{getSearchableIcon(cellContent)}</div>
        </Popover>
      )
    },
    {
      dataField: "df1",
      isDummyField: true,
      headerClasses: "column-id",
      text: labels.actions,
      formatter: (cellContent, row) => {
        return (
          <div className="column-id">
            <Button
              className="fa fa-cloud-download buttonStyle"
              size="sm"
              onClick={event => {
                event.preventDefault();
                event.stopPropagation();
                this.onDocumentDownload(row);
              }}
            />
          </div>
        );
      }
    }
  ];

  render() {
    return <Table data={this.state.similarDocuments} columns={this.columns} />;
  }
}

export default withKeycloak(SimilarDocuments);
